import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { Subject } from 'rxjs';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel } from '../bases';
import { onCreateFactoryAuth } from './auth';
@BindAll()
export class OutagesNoticeController {
  Model = new BaseModel({ type: 'object' });
  /**
   * 公告异步数据加载订阅
   * @type {Promise<any>}
   * @memberof ControllerUser
   */
  readonly OuatagesSubject = new Subject();
  /**
   * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
   * 除非是地址栏解析或者其他方式等等
   * @memberof SystemController
   */
  readonly Auth = onCreateFactoryAuth();

  get noticeList() {
    return this.Model.get('noticeList', []);
  }

  // 获取停机公告信息
  async getNoticeInfo(positionType) {
    let res: any = await AjaxBasics.request({
      ...EnumAPI.outagesNotice_notice_get_by_position,
      body: { positionType, tenantCode: 'BPP' },
    });
    this.Model.merge({ noticeList: res });
    this.OuatagesSubject.complete();
  }

  // 获取所有停机菜单id
  getAllOutageMenu(positionType) {
    return AjaxBasics.request({
      ...EnumAPI.outagesNotice_notice_get_by_menu,
      body: { tenantCode: 'BPP', positionType },
    });
  }

  // 获取停机白名单
  getOutageWhite(positionType) {
    return AjaxBasics.request({
      ...EnumAPI.outagesNotice_notice_white_by_tenantCode,
      body: { tenantCode: 'BPP', positionType },
    });
  }

  // 获取当前用户的停机菜单
  async getUserOutageMenu(positionType) {
    try {
      let outageMenu: any = [];
      let white = [];
      const username = lodash.get(this.Auth.JwtDecoded, 'username', '');

      if (this.Auth.AccessToken) {
        const res = await AjaxBasics.forkJoinCatchError([
          this.getAllOutageMenu(positionType),
          this.getOutageWhite(positionType),
        ]);
        outageMenu = lodash.get(res, '[0]');
        white = lodash.get(res, '[1]');
      } else {
        outageMenu = await this.getAllOutageMenu(positionType);
      }

      const userWhite = lodash.find(white, ['white', username]);
      if (lodash.isEmpty(userWhite)) {
        return outageMenu;
      }
      return lodash.difference(outageMenu, lodash.get(userWhite, 'menuList'));
    } catch (error) {
      return [];
    }
  }

  // 获取LCIC AI伙伴助手是否停机
  async getLcicOutage() {
    return AjaxBasics.request({
      ...EnumAPI.idass_lcic_shutdown,
    });
  }
}
